import React from 'react';
import ChurnRiskPanel from '../components/ChurnRiskPanel';
import ComplaintRiskPanel from '../components/ComplaintRiskPanel';
import CustomerExperienceFilterBar from '../components/CustomerExperienceFilterBar';
import CustomerExperienceTable from '../components/CustomerExperienceTable';
import ExperienceRiskPanel from '../components/ExperienceRiskPanel';
import ExperienceSummaryCards from '../components/ExperienceSummaryCards';
import ExperienceTrendPanel from '../components/ExperienceTrendPanel';
import ProactiveOutreachPanel from '../components/ProactiveOutreachPanel';
import useCustomerExperienceData from '../hooks/useCustomerExperienceData';
import { AppShell, PageContainer } from '../../ui-system';

const CustomerExperiencePage = () => {
  const {
    summary,
    filteredRecords,
    trends,
    areas,
    outreachCandidates,
    highRiskCustomers,
    filters,
    setFilters,
    refreshAll,
    isLoading,
    error,
  } = useCustomerExperienceData();

  return (
    <AppShell>
      <PageContainer>
      <div className="admin-page-surface mx-auto w-full max-w-[1800px] space-y-4 p-4 lg:py-6">
        <header className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
          <div className="text-xs uppercase tracking-[0.16em] text-slate-400">Customer Experience Intelligence</div>
          <h1 className="mt-1 text-2xl font-semibold">Panel Pengalaman Pelanggan</h1>
          <p className="mt-1 text-sm text-slate-400">
            Prioritas risiko komplain, churn, dan outreach proaktif berbasis sinyal monitoring, ticketing, dan billing.
          </p>
        </header>

        <CustomerExperienceFilterBar filters={filters} setFilters={setFilters} areas={areas} onRefresh={refreshAll} />

        {isLoading ? (
          <div className="rounded-xl border border-slate-800 bg-slate-900/70 p-4 text-sm text-slate-400">Memuat customer experience...</div>
        ) : null}

        {error ? (
          <div className="rounded-xl border border-red-500/50 bg-red-500/10 p-4 text-sm text-red-200">
            {error?.message || 'Gagal memuat customer experience intelligence'}
          </div>
        ) : null}

        {!isLoading && !error ? (
          <>
            <ExperienceSummaryCards summary={summary} />
            <div className="grid gap-4 xl:grid-cols-3">
              <ExperienceRiskPanel records={highRiskCustomers} />
              <ComplaintRiskPanel records={filteredRecords} />
              <ChurnRiskPanel records={filteredRecords} />
            </div>
            <div className="grid gap-4 xl:grid-cols-[1.1fr_0.9fr]">
              <ProactiveOutreachPanel items={outreachCandidates} />
              <ExperienceTrendPanel trends={trends} />
            </div>
            <CustomerExperienceTable records={filteredRecords} />
          </>
        ) : null}
      </div>
      </PageContainer>
    </AppShell>
  );
};

export default CustomerExperiencePage;
